import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../reducers'

const selectOrganizationRoleStore = (state: RootState) =>
  state.organizationRoles

export const selectOrganizationRoleState = createSelector(
  [selectOrganizationRoleStore],
  orgRoleStore => ({
    currentRole: orgRoleStore.currentRole,
    currentRoleClaims: orgRoleStore.currentRoleClaims,
    loading: orgRoleStore.loading,
    claimsLoading: orgRoleStore.claimsLoading,
    error: orgRoleStore.error,
    keyword: orgRoleStore.keyword,
  }),
)
